import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import UPDATE_OON_CONSENT_QUERY from './updateOONConsent.gql';

const parseResult = result => {
  const initialState = {};

  const updatePopup = get(result, 'core.updatePopup');

  return {
    ...initialState,
    ...updatePopup,
  };
};

export const useUpdateOONConsentQuery = options => {
  const [queryResult, queryAction] = useQuery(UPDATE_OON_CONSENT_QUERY, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
